<!--Navbar-->
<div class="main_header">
  <!-- <div class="row ka-em-header-content">
    <span>Kaakateeya Employee Application</span>
  </div> -->
  <mdb-navbar SideClass="navbar navbar-expand-lg navbar-dark main-header nav-background" [containerInside]="false">
    <!-- Navbar brand -->
  
    <mdb-navbar-brand>
      <a class="navbar-brand" (click)="navigateToDashboard()">
        <img src="../../../assets/img/dashboard/ka_logo.png" class="img-fluid wow fadeIn" height="70">
      </a>
    </mdb-navbar-brand>
  
    <!-- Collapsible content -->
    <links>
  
      <!-- Links -->
      <ul class="navbar-nav mr-auto">
  
          <li class="nav-item dropdown" dropdown *ngFor="let page of employeePagePermission">
            <a dropdownToggle mdbWavesEffect type="button" class="nav-link ka-header-a dropdown-toggle waves-light" 
              *ngIf="page?.hasAccess" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
              {{page.pageName}}<span class="caret"></span></a>
              <div *dropdownMenu class="dropdown-menu ka-header-dropdown dropdown dropdown-primary" aria-labelledby="dropdownMenuButton">
                <div *ngFor="let subMenu of page?.menuItems">
                  <div *ngIf="subMenu?.subMenuItems?.length === 0; else subMenuItem">
                    <li>
                    <a *ngIf="subMenu?.hasAccess" (click)="redirectToPages(subMenu)" class="dropdown-item ka-header-dropdown-submenu">{{subMenu.menuItemName}}</a>
                    </li>
                  </div>
                  <hr class="menu-linebreak">
                  
                  <ng-template #subMenuItem>
                    <li class="dropdown-submenu">
                      <a *ngIf="subMenu?.hasAccess" class="dropdown-item ka-header-dropdown-submenu">{{subMenu.menuItemName}}</a>
                      <ul class="dropdown-menu ka-header-dropdown">
                        <li class="dropdown-item ka-header-sub-dropdown-menu" *ngFor="let item of subMenu?.subMenuItems">
                          <a *ngIf="item?.hasAccess" (click)="subMenuRedirection(item)">{{item.subMenuItemName}}</a>
                        </li>
                      </ul>
                    </li>
                  </ng-template>

                </div>
              </div>
          </li>

        
            <!-- Dropdown -->
            <!-- <li class="nav-item dropdown" dropdown>
              <a dropdownToggle mdbWavesEffect type="button" class="nav-link dropdown-toggle waves-light" 
              data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                Registration<span class="caret"></span></a>
              <div *dropdownMenu class="dropdown-menu dropdown dropdown-primary" aria-labelledby="dropdownMenuButton">
                <a class="dropdown-item waves-light" mdbWavesEffect href="/customerregistration">Customer New Registration</a>
                <a class="dropdown-item waves-light" mdbWavesEffect href="/editViewProfile" >Edit/View Profile</a>
               
                <a class="dropdown-item waves-light" mdbWavesEffect (click)="navigateToRegistrationProfileValidation()">Registration Profile Validation</a>
                <li class="dropdown-submenu">
                  <a class="dropdown-item waves-light" mdbWavesEffect >Services</a>
                  <ul class="dropdown-menu">
                    <li class="dropdown-item"><a href="/expressInterest">Express Interest</a></li>
                    <li class="dropdown-item"><a  href="/communicationLog">Communication Log</a></li>
                    <li class="dropdown-item"><a  href="/serviceSlideShow">Services SlideShows</a></li>
                  </ul>
                </li>
                <a class="dropdown-item waves-light" mdbWavesEffect (click)="navigateToPaymentDetails()">Payment Details</a>
                <li class="dropdown-submenu">
                  <a class="dropdown-item waves-light" mdbWavesEffect >Settlement Details</a>
                  <ul class="dropdown-menu">
                    <li class="dropdown-item"><a >Settle Delete Profile</a></li>
                    <li class="dropdown-item"><a  >View/Upload Settlement</a></li>
                  </ul>
                </li>
                <li class="dropdown-submenu">
                  <a class="dropdown-item waves-light" mdbWavesEffect >Payment</a>
                  <ul class="dropdown-menu">
                    <li  *ngIf = "loginData.isAdmin ==1 || loginData.isManagement ==1 " class="dropdown-item"><a href="/paymentOffers">Payment Offer</a></li>
                    <li class="dropdown-item"><a  href="/paymentAuthorization">Payment Authorization</a></li>
                  </ul>
                </li>
                <a class="dropdown-item waves-light" mdbWavesEffect href="/viewProfilePage">Customer New Admin Profile</a>
                <a class="dropdown-item waves-light" mdbWavesEffect >Customer Fact Sheet</a>
                <a class="dropdown-item waves-light" mdbWavesEffect >Customer WhatsApp Profile</a>
                <a class="dropdown-item waves-light" mdbWavesEffect href="/customerNewAdminProfile">Admin Partner Preferences</a>

              </div>
            </li> -->
           <!-- Dropdown -->
           <!-- <li class="nav-item dropdown" dropdown>
            <a dropdownToggle mdbWavesEffect type="button" class="nav-link dropdown-toggle waves-light" 
            mdbWavesEffect >
              Search<span class="caret"></span></a>
            <div *dropdownMenu class="dropdown-menu dropdown dropdown-primary" role="menu">
              <a class="dropdown-item waves-light" mdbWavesEffect (click)="navigateToSearchProfile('general','')">General Search</a>
              <a class="dropdown-item waves-light" mdbWavesEffect (click)="navigateToSearchProfile('advanced','')">Advanced Search</a>
              <a class="dropdown-item waves-light" mdbWavesEffect (click)="navigateToSearchProfile('keyword','')">Keyword Search</a>
            </div>
          </li> -->
           <!-- Dropdown -->
           <!-- <li class="nav-item dropdown" dropdown>
            <a dropdownToggle mdbWavesEffect type="button" class="nav-link dropdown-toggle waves-light" mdbWavesEffect>
              My Account<span class="caret"></span></a>
            <div *dropdownMenu class="dropdown-menu dropdown dropdown-primary" role="menu">
              <a class="dropdown-item waves-light" mdbWavesEffect >My Profile</a>
              <a class="dropdown-item waves-light" mdbWavesEffect href="/marketingSlideShow">Marketing Slide Show</a>
              <a class="dropdown-item waves-light" mdbWavesEffect >Quick Marketing Unpaid Profiles</a>
              <a class="dropdown-item waves-light" mdbWavesEffect href="/matchfollowup">Match Followup Slide Show</a>
              <a class="dropdown-item waves-light" mdbWavesEffect >Unpaid Match Followup Slide Show</a>
              <a class="dropdown-item waves-light" mdbWavesEffect href="/matchMeeting"> Match Meeting Entry Form</a>
              <a class="dropdown-item waves-light" mdbWavesEffect href="/guestTicketCreation"> Ticket Creation</a>
              <a class="dropdown-item waves-light" mdbWavesEffect href="/lst"> LST</a>
              <a class="dropdown-item waves-light" mdbWavesEffect > My Assigned Photos</a>
              <a class="dropdown-item waves-light" mdbWavesEffect > LST</a>
              <a class="dropdown-item waves-light" mdbWavesEffect > Experied Marketing Tickets</a>
              <a class="dropdown-item waves-light" mdbWavesEffect > Assign Experied Marketing Tickets</a>

            </div>
          </li> -->
              <!-- Dropdown -->
        <!-- <li class="nav-item dropdown" dropdown>
          <a dropdownToggle mdbWavesEffect type="button" class="nav-link dropdown-toggle waves-light" mdbWavesEffect>
            Maintenance Work<span class="caret"></span></a>
          <div *dropdownMenu class="dropdown-menu dropdown dropdown-primary" role="menu">
            <li class="dropdown-submenu">
              <a class="dropdown-item waves-light" mdbWavesEffect >Unassigned Info</a>
              <ul class="dropdown-menu">
                <li class="dropdown-item"><a >Photos</a></li>
              </ul>
            </li>          
            <a class="dropdown-item waves-light" mdbWavesEffect href="/profileAssign">Assign Profile (New)</a>
            <a *ngIf = "loginData.isAdmin ==1 || loginData.isManagement ==1 "
            class="dropdown-item waves-light" mdbWavesEffect href="/marketingReassign">Marketing Reassign Profile</a>
            <a class="dropdown-item waves-light" mdbWavesEffect >Profile Modification By Customer</a>
            <a class="dropdown-item waves-light" mdbWavesEffect >Email Bounce</a>
            <a class="dropdown-item waves-light" mdbWavesEffect >Customer Message Verification</a>
            <a class="dropdown-item waves-light" mdbWavesEffect >Marketing Commission Report</a>
            <a class="dropdown-item waves-light" mdbWavesEffect >View/Create Success Stories</a>
            <a class="dropdown-item waves-light" mdbWavesEffect >Broker Profiles</a>
            <a class="dropdown-item waves-light" mdbWavesEffect >Amount Deposited In Bank</a>

          </div>
        </li> -->
  
        <!-- Dropdown -->
        <!-- <li class="nav-item dropdown" dropdown>
          <a dropdownToggle mdbWavesEffect type="button" class="nav-link dropdown-toggle waves-light" mdbWavesEffect>
            Admin Forms<span class="caret"></span></a>
          <div *dropdownMenu class="dropdown-menu dropdown dropdown-primary" role="menu">
            <li class="dropdown-submenu">
              <a class="dropdown-item waves-light" mdbWavesEffect >Employee</a>
              <ul class="dropdown-menu">
                <li class="dropdown-item">
                  <a class="dropdown-item waves-light" mdbWavesEffect href="/employee-permission">Employee Permissions</a>
                </li>
                <li class="dropdown-item"><a  >Employee Login Logout Report</a></li>
              </ul>
            </li> 
            <a class="dropdown-item waves-light" href="/update-branch" mdbWavesEffect >Update Branch Ip</a>         
            <a class="dropdown-item waves-light" mdbWavesEffect >Update Branch Ip</a>
            <a class="dropdown-item waves-light" mdbWavesEffect >No Matches Profiles</a>
            <a class="dropdown-item waves-light" mdbWavesEffect >Sample Mail Formats</a>
            <a class="dropdown-item waves-light" mdbWavesEffect >Settlement Info</a>
            <a class="dropdown-item waves-light" mdbWavesEffect >Master Page</a>
            <a class="dropdown-item waves-light" mdbWavesEffect >Broker Entry Form</a>
            <a class="dropdown-item waves-light" mdbWavesEffect >Broker Registration</a>
            <a class="dropdown-item waves-light" mdbWavesEffect >Schedule Page</a>
            <a class="dropdown-item waves-light" mdbWavesEffect >Accounts Page</a>
          </div>
        </li> -->
  
         <!-- Dropdown -->
         <!-- <li class="nav-item dropdown" dropdown>
          <a dropdownToggle mdbWavesEffect type="button" class="nav-link dropdown-toggle waves-light" mdbWavesEffect>
            Reports<span class="caret"></span></a>
          <div *dropdownMenu class="dropdown-menu dropdown dropdown-primary" role="menu">
            <a class="dropdown-item waves-light" mdbWavesEffect >Review Pending Profiles</a>
            <a class="dropdown-item waves-light" mdbWavesEffect >Payment Reports</a>
            <a class="dropdown-item waves-light" mdbWavesEffect >Registration Report</a>
            <a class="dropdown-item waves-light" mdbWavesEffect >Match Meeting Count Report</a>
            <a class="dropdown-item waves-light" mdbWavesEffect >Settle Delete Profiles</a>
            <a class="dropdown-item waves-light" mdbWavesEffect >No Profile Grade</a>
            <a class="dropdown-item waves-light" mdbWavesEffect >Email Bounce Report</a>
            <a class="dropdown-item waves-light" mdbWavesEffect >Amount Deposited Bank Report</a>
            <a class="dropdown-item waves-light" mdbWavesEffect >Employee Work/Pending Report</a>
            <a class="dropdown-item waves-light" mdbWavesEffect >Teams Head Report</a>
          </div>
        </li> -->
  
      </ul>
          <!-- Links -->
  
          <ul class="navbar-nav">
            <li class="nav-item">
              <a class="nav-link btnAlign" (click)="getLoggedInUsers()">Presently Online Users
              </a>
              <span class="loggedInCount" *ngIf="loggedInCustomers?.length > 0">{{loggedInCustomers[0]['TotalRows']}}</span>
              <span class="loggedInCount" *ngIf="loggedInCustomers?.length <= 0">0</span>
            </li>
            <li class="pt-2 ka-notifications" mdbTooltip="Notification" placement="Right" dropdown *ngIf="isEmailFlag">
              <div dropdownToggle>
                <img mdbWavesEffect src="../../../../assets/img/home/notification_ic.svg" alt="" >
                <span class="count" *ngIf="message.length > 0">{{message[0]?.notificationCount}}</span>
                <span class="count" *ngIf="message.length <= 0">0</span>
              </div>
              <div *dropdownMenu class="dropdown-menu dropdown dropdown-primary m-0 p-0" role="menu" style="width: 275px;border-radius: 4px;color: #ddebff;">
                <div *ngIf="message.length > 0 " class="notification">
                  <div class="dropdown-item waves-light notificationHolder p-2" mdbWavesEffect href="#"
                    *ngFor="let data of message" (click)="navigateToEditviewDashboard(data)">
                    <img src="{{data?.customerPhoto}}" alt="">
                    <span style="font-size: 12px;white-space: normal;">{{data?.customerName}} <br/>
                      <span>{{data?.actionName}}</span>
                    </span>
                  </div>
                  <span class="ka-emp-viewAllNotification" (click)="getAllNotifications()">View All</span>
                </div>
                <div *ngIf="message.length < 1" class="noIcon">
                  <img src="../../../../assets/img/register/no_notifications.svg" alt="">
                  <p>No Notification Found</p>
                </div>
      
              </div>
            </li>
          </ul>
          
          
      <!-- Links -->
  
      <ul class="navbar-nav ml-auto nav-flex-icons">
        <li class="ka-profile-name " *ngIf="loginData && loginData['firstName']!=undefined">
          <div>
            <a  class="nav-item">Welcome {{loginData['firstName']}}</a>
          </div>
          <div style="float: right;">
            <span> - </span>
            <a class="nav-item font-italic">{{loginData['empType']}}</a>
          </div>
        </li>
        <li class="nav-item avatar dropdown" dropdown>
          <a dropdownToggle mdbWavesEffect type="button" class="waves-light" mdbWavesEffect>
            <img *ngIf="loginData && loginData['photo']!=undefined" src="{{loginData['photo']}}" alt="" class="profile-image"></a>
          <div *dropdownMenu class="dropdown-menu ka-header-dropdown dropdown-menu-right dropdown dropdown-primary" role="menu">
            <a class="dropdown-item waves-light" mdbWavesEffect (click)="showBasicModal('logout')">Log out</a>
            <a class="dropdown-item waves-light" mdbWavesEffect (click)="showBasicModal('changePassword')">Change Password</a>
  
  
          </div>
        </li>
      </ul>
    </links>
    <!-- Collapsible content -->
  
  </mdb-navbar>
  </div>
  <div mdbModal #basicModal="mdbModal" class="modal fade" tabindex="-1" role="dialog" aria-labelledby="myBasicModalLabel"
    aria-hidden="true"  [config]="{backdrop: true, ignoreBackdropClick: true,  keyboard: false}">
    <div class="modal-dialog modal-md" role="document">
  
      <div class="modal-content">
        <button type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="basicModal.hide()">
          <span aria-hidden="true" class="">&times;</span>
        </button>
        <div class="row text-left">
  
          <!--Grid column-->
          <div class="col-md-12 rmSectionPopup">
            <div class="row p-2 m-2">
  
              <div class="col-md-12 rmDetailsSectionPopup">
                <!-- <img src="../../../../assets/img/dashboard/rm_temp.PNG" /> -->
                <p class="m-0 p-0" *ngIf="!isChangePassword">
  
                  Are you sure you want to logout?<br>
  
                </p>
                <p class="m-0 p-0" *ngIf="isChangePassword">
  
                  Are you sure to change password<br>
  
                </p>
                <div class="action-buttons">
                  <p (click)="logout()">Yes</p>
                  <p (click)="[basicModal.hide()]">No</p>
                </div>
  
              </div>
            </div>
  
          </div>
  
          <!--Grid column-->
  
  
  
        </div>
      </div>
    </div>
  </div>
  <ng-container *ngComponentOutlet="LoaderComponent">
  </ng-container>
  
  <div mdbModal #forgotPasswordModal="mdbModal" class="modal fade" style="
  pointer-events: none;" tabindex="-1" role="dialog" aria-labelledby="myBasicModalLabel" aria-hidden="true"
   [config]="{backdrop: true, ignoreBackdropClick: true,  keyboard: false}">
    <div class="modal-dialog modal-md" role="document" >
      <div class="modal-content" style="width: none !important;">
        <button type="button" class="close" data-dismiss="modal" aria-label="Close"
          (click)="resetModals()">
          <span aria-hidden="true" class="">&times;</span>
        </button>
        <div class="row text-left">
          
          <!--Grid column-->
          <br>
          <!-- <div class="col-md-6 ka-nopadding ipadPotraitImage">
            <div class="col-12 col-md-12 col-lg-12 ka-fullHeight text-center" style="height: 100% !important;">
              <img [src]="loginImgUrl" style="height: 100% !important;" class="img-fluid ka-login-img ka-fullHeight" />
            </div>
          </div> -->
  
       
  
          <div #forgotPasswordModal class="col-md-12 ipadPotratFormLogin" >
            <div class="otpSection">
              <p class="ka-section-head-text mt-3">Change Password </p>
              <div> 
                <form class="ka-forget-password" [formGroup]="emailOtpForm">
                  <div>
                    <label for="" class="text-left ka-float-left ka-custom-margin-lable-bottom mt-4"> New Password</label>
  
                    <div class="passwordHolder">
                      <input [type]="_showPassword ? 'text' : 'password'" formControlName="password"
                        id="password" mdbInput class="form-control  "
                        (keypress)="omit_special_char_withNumbers_password1($event)" (input)="ComparePassword()"
                        placeholder="Enter Password" required>
                      <span class="input-group-addon" (click)="showPassword()">
                        <i [class]="!_showPassword ? 'fa fa-eye-slash' : 'fa fa-eye'"></i>
                      </span>
  
                    </div>
                    <div *ngIf="  _contactEmailOTPSubmitted && emailOtpForm.controls['password'].errors "
                      class="error-msg1">
                      <div [hidden]=" _contactEmailOTPSubmitted && !emailOtpForm.controls['password'].errors.required">
                        Password is required.</div>
  
  
                    </div>
                    <div class="error-msg1">
                      <!-- <div
                        *ngIf="emailOtpForm.controls['password'].errors?.minlength || emailOtpForm.controls['password'].errors?.maxlength">
                        Password must contain atleast 6 to 18 characters
                      </div> -->
                    </div>
  
                  </div>
  
                  <div>
                    <label for="" class="text-left ka-float-left ka-custom-margin-lable-bottom mt-4">Confirm
                      Password</label>
                    <div class="passwordHolder">
                      <input [type]="_showChangePassword ? 'text' : 'password'" formControlName="confirmPassword"
                        id="confirmPassword" mdbInput class="form-control "
                        (keypress)="omit_special_char_withNumbers_password1($event)" (input)="ComparePassword()"
                        placeholder="Enter Confirm Password" required>
                      <span class=" input-group-addon" (click)="showChangePassword()">
                        <i [class]="!_showChangePassword ? 'fa fa-eye-slash' : 'fa fa-eye'"></i>
                      </span>
                    </div>
                    <div *ngIf=" _contactEmailOTPSubmitted && emailOtpForm.controls['confirmPassword'].errors"
                      class="error-msg1">
                      <div
                        [hidden]="_contactEmailOTPSubmitted && !emailOtpForm.controls['confirmPassword'].errors.required">
                        Confirm Password is required.</div>
  
  
                    </div>
                    <div *ngIf="_contactEmailOTPSubmitted && !isPasswordMatched" class="invalid-feedback">
                      Password not matching
                    </div>
  
                  </div>
                  <label class="mt-3">Enter OTP</label>
                  <div class="row mt-3  ka-otp-input" style="justify-content: center;">
  
  
                    <div class="row ka-otp-input">
                      <div class="col-2">
                        <input type="number" #otp1 maxlength="1" max="1" class="form-control" formControlName="otp1"
                          (keypress)="omit_special_char_withNumbers_custom($event)"
                          (input)="onInputEntry($event, otp2, undefined, 'otp1')" (focus)="onFocusInput($event)"
                          [ngClass]="{ 'ka-invlid-textBox': _contactEmailOTPSubmitted && fval.otp1.errors }">
                      </div>
                      <div class="col-2">
                        <input type="number" #otp2 maxlength="1" max="1" class="form-control" formControlName="otp2"
                          (keypress)="omit_special_char_withNumbers_custom($event)"
                          (keydown)="omit_special_char_withNumbers_custom_backspace($event,otp1)"
                          [ngClass]="{ 'ka-invlid-textBox': _contactEmailOTPSubmitted && fval.otp2.errors }"
                          (input)="onInputEntry($event, otp3,otp1,'otp2')">
                      </div>
                      <div class="col-2">
                        <input type="number" #otp3 maxlength="1" max="1" class="form-control" formControlName="otp3"
                          (keypress)="omit_special_char_withNumbers_custom($event)"
                          (keydown)="omit_special_char_withNumbers_custom_backspace($event, otp2)"
                          [ngClass]="{ 'ka-invlid-textBox': _contactEmailOTPSubmitted && fval.otp3.errors }"
                          (input)="onInputEntry($event, otp4,otp2,'otp3')">
                      </div>
                      <div class="col-2">
                        <input type="number" #otp4 maxlength="1" max="1" class="form-control" formControlName="otp4"
                          (keypress)="omit_special_char_withNumbers_custom($event)"
                          (keydown)="omit_special_char_withNumbers_custom_backspace($event, otp3)"
                          [ngClass]="{ 'ka-invlid-textBox': _contactEmailOTPSubmitted && fval.otp4.errors }"
                          (input)="onInputEntry($event, otp5,otp3,'otp4')">
                      </div>
                      <div class="col-2">
                        <input type="number" max="1" #otp5 maxlength="1" class="form-control" formControlName="otp5"
                          (keypress)="omit_special_char_withNumbers_custom($event)"
                          (keydown)="omit_special_char_withNumbers_custom_backspace($event, otp4)"
                          [ngClass]="{ 'ka-invlid-textBox': _contactEmailOTPSubmitted && fval.otp5.errors }"
                          (input)="lastInput($event,otp4,'otp5')">
                      </div>
                      <div *ngIf="_contactEmailOTPSubmitted && fval.otp5.errors" style="margin-top: 0;
                      position: inherit !important;
                      text-align: left !important;
                      margin-left: 27px;" class="invalid-feedback">
                        <div *ngIf="fval.otp5.errors.required">
                          OTP required to verify your mobile number
                        </div>
                      </div>
                     
                    </div>
                    <div>
  
                    </div>
        
                  </div>
  
                  <div class="row ka-otp-input" style="justify-content: center;">
                    <p class="h4  ka-section-head-text ka-red-text" *ngIf="!isResendButtonShow">
                      <a  (click)="resendOTP(custId,typeId)"
                      >Resend OTP</a></p>
                      <p class="otpTimer" *ngIf="isResendButtonShow">
                        You can resend OTP in {{otpTimer}}s
                      </p>
                  </div>
                  <div class="row ka-otp-input" style="justify-content: center;">
                    <p *ngIf="isError" class="error-message mt-2" >{{_message}}</p>
  
                  </div>
  
                  <button mdbBtn
                  class="ka-white-button tButton ka-btn-primary btn-success btn ka-custom-button-login mb-3"
                  mdbWavesEffect type="submit" (click)="verifyEmailOtp()">Submit</button>
                </form>
              </div>
            
  
            </div>
          </div>
  
        </div>
      </div>
    </div>
  </div>
  <div mdbModal #otpModal="mdbModal" class="modal fade" tabindex="-1" role="dialog"
    aria-labelledby="myBasicModalLabel" aria-hidden="true"  [config]="{backdrop: true, ignoreBackdropClick: true,  keyboard: false}">
    <div class="modal-dialog modal-md modal-dialog-centered" role="document">
  
      <div class="modal-content">
        <button type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="closeOTPModal()">
          <span aria-hidden="true" class="">&times;</span>
        </button>
        <div class="row text-left">
  
          <!--Grid column-->
          <div class="col-md-12 rmSectionPopup">
            <div class="row p-2 m-2">
  
              <div class="col-md-12 rmDetailsSectionPopup">
                <!-- <img src="../../../../assets/img/dashboard/rm_temp.PNG" /> -->
                <p class="mt-2 p-0">{{resetOTPResponse}} </p>
  
                <div class="action-buttons">
                  <button mdbBtn class="ka-white-button  tButton ka-btn-primary btn-success btn mb-3 mt-2"
                    mdbWavesEffect type="submit" (click)="closeOTPModal()">ok
                  </button>
  
  
  
                </div>
  
              </div>
            </div>
  
          </div>
  
          <!--Grid column-->
  
  
  
        </div>
      </div>
    </div>
  </div>
  
  
  <div mdbModal #successModal="mdbModal" class="modal fade" tabindex="-1" role="dialog"
      aria-labelledby="myBasicModalLabel" aria-hidden="true"  [config]="{backdrop: true, ignoreBackdropClick: true,  keyboard: false}">
      <div class="modal-dialog modal-md modal-dialog-centered" role="document">
  
        <div class="modal-content">
          <button type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="hideSuccessModal()">
            <span aria-hidden="true" class="">&times;</span>
          </button>
          <div class="row text-left">
  
            <!--Grid column-->
            <div class="col-md-12 rmSectionPopup">
              <div class="row p-2 m-2">
  
                <div class="col-md-12 rmDetailsSectionPopup">
                  <!-- <img src="../../../../assets/img/dashboard/rm_temp.PNG" /> -->
                  <p class="mt-2 p-0">Password changed successfully.  </p>
  
                  <div class="action-buttons">
                    <button mdbBtn class="ka-white-button  tButton ka-btn-primary btn-success btn mb-3 mt-2"
                      mdbWavesEffect type="submit" (click)="hideSuccessModal()">ok
                    </button>
  
  
  
                  </div>
  
                </div>
              </div>
  
            </div>
  
            <!--Grid column-->
  
  
  
          </div>
        </div>
      </div>
    </div>